module.exports = __webpack_public_path__ + "img/knop-geschiedenis.3c81ea37.jpg";